import { render, staticRenderFns } from "./msgtplCate.vue?vue&type=template&id=91c6f22e&scoped=true"
import script from "./msgtplCate.vue?vue&type=script&lang=js"
export * from "./msgtplCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c6f22e",
  null
  
)

export default component.exports